module.exports = __webpack_public_path__ + "img/cloud-raining-01.ed22fe56.svg";